import { Location } from "react-router-dom";

export function getEncodedCurrentPath(location: Location): string {
  return encodeURIComponent(`${location.pathname}${location.search}`);
}
